/**
 * @fileoverview Constants for Product Component Library deployments
 */

import { TRP_DOMAINS } from '@trp-dms-digital-shared/ds-ui-library-common';

/**
 * POP URL base after TRP Domain
 */
export const POP_URL_ROOT_PATH =
  'products/product-ui/product-component-library';

/**
 * POP URL base for versioned releases after TRP Domain
 */
export const POP_URL_ROOT_VERSIONED = `${POP_URL_ROOT_PATH}/versioned`;

/**
 * root URLs for the POP in the CDN
 */
export const PopCDNRootUrls = {
  DEV: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.DEV).href,
  SIT: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.SIT).href,
  STAGE: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.STAGE).href,
  PROD: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.PROD).href,
} as const;

/**
 * root URLs for the POP numbered-versions in the CDN
 */
export const POP_URL_ROOTS = {
  DEV: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.DEV).href,
  SIT: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.SIT).href,
  STAGE: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.STAGE).href,
  PROD: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.PROD).href,
} as const;
